module.exports = require("./pt-MO");